module.exports = __webpack_public_path__ + "img/cover-slot-bg.bd9dff45.jpg";